import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import ShareableLinks from './pages/ShareableLinks';
import ShareableLink from './pages/ShareableLink';

export default [
  {
    path: ':shareableLinkId',
    element: ShareableLink,
  },
  {
    index: true,
    element: ShareableLinks,
  },
] as Array<EnhancedRouteProps>;
